import React, { useMemo } from 'react';

import { Tab, TabContent } from '@unimed-fesp/components';

// #region Componentes
import EmptyContent from '../../molecules/EmptyContent';
import LoadingSpinning from '../../molecules/LoadingSpinning';

import ParametrizacaoContratantes from '../ParametrizacaoContratantes';

import DadosAcesso from './DadosAcesso';
import DadosGerais from './DadosGerais';
import HistoricoMovimentacoes from './HistoricoMovimentacoes';
// #endregion

function TabFormUsuario({
  usuarioParams,
  setUsuarioParams,
  contatoParams,
  setContatoParams,
  dadosAcessoParams,
  setDadosAcessoParams,
  usuarioDadosGerais,
  usuarioDadosAcesso,
  usuarioHistoricoMovimentacao,
  handleAcaoUsuarioById,
  handleActiveTab,
  setPaginationParams,
  paginationParams,
  handlePageChangeKeyDown,
  idUsuario,
  useField,
  handleChangePage,
}) {
  const tabs = useMemo(() => {
    const tabsMemo = [
      {
        children: <>dados gerais</>,
        color: '#00995D',
        name: 'dadosGerais',
      },
      {
        children: <>dados de acesso</>,
        color: '#00995D',
        name: 'dadosAcesso',
      },
      {
        children: <>parâmetros</>,
        color: '#00995D',
        name: 'parametros',
      },
      {
        children: <>histórico de movimentações</>,
        color: '#00995D',
        name: 'historicoMovimentacao',
        width: 'min-content',
      },
    ];

    return tabsMemo;
  }, []);

  function handleRenderTable(tabName = null) {
    if (usuarioDadosGerais.loading) {
      return <LoadingSpinning />;
    }
    if (usuarioDadosGerais.response) {
      return (
        <DadosGerais
          usuarioParams={usuarioParams}
          setUsuarioParams={setUsuarioParams}
          contatoParams={contatoParams}
          setContatoParams={setContatoParams}
          usuarioDadosGerais={usuarioDadosGerais.response}
          useField={useField}
          handleChangePage={handleChangePage}
        />
      );
    }
    return <EmptyContent />;
  }

  function handleRenderTableHistorico() {
    if (usuarioHistoricoMovimentacao.loading) {
      return <LoadingSpinning />;
    }

    if (usuarioHistoricoMovimentacao.response.size > 0) {
      return (
        <HistoricoMovimentacoes
          usuarioHistoricoMovimentacao={
            usuarioHistoricoMovimentacao.response.data.data
          }
          pageData={usuarioHistoricoMovimentacao.response.data}
          sizeData={usuarioHistoricoMovimentacao.response.size}
          setPaginationParams={setPaginationParams}
          paginationParams={paginationParams}
          handlePageChangeKeyDown={handlePageChangeKeyDown}
          handleChangePage={handleChangePage}
        />
      );
    }
    return <EmptyContent />;
  }

  return (
    <>
      <Tab tabs={tabs} handleChangeTab={handleActiveTab}>
        <TabContent contentForTab="dadosGerais">
          {handleRenderTable()}
        </TabContent>
        <TabContent contentForTab="dadosAcesso">
          <DadosAcesso
            dadosAcessoParams={dadosAcessoParams}
            setDadosAcessoParams={setDadosAcessoParams}
            usuarioDadosAcesso={usuarioDadosAcesso}
            handleAcaoUsuarioById={handleAcaoUsuarioById}
          />
        </TabContent>
        <TabContent contentForTab="parametros">
          <ParametrizacaoContratantes
            idUsuario={idUsuario}
            roleUsuario={usuarioParams.tipoPerfil}
          />
        </TabContent>
        <TabContent contentForTab="historicoMovimentacao">
          {handleRenderTableHistorico()}
        </TabContent>
      </Tab>
    </>
  );
}

export default TabFormUsuario;
